import * as moment from 'moment'

import { EligibilityRule } from '../../models/eligibility-rule-set'
import { MappableModel, EligibilityCredential, EligibilityStatusTag, Organization } from '../../models'

export abstract class CredentialItem extends MappableModel {

  public eligibilityStatusTag: EligibilityStatusTag
  public validityLabel: string

  public credential: EligibilityCredential
  public organization: Organization
  public rule: EligibilityRule

  protected defaultStatusTag(): void {
    const value = this.credential.eligibility_status || this.credential.status || 'required'
    this.setStatusTag({ color: 'gray', value })
  }

  protected getDate(date: string): string {
    return moment.tz(date, this.organization.timezoneOrDefault).format('MMM D, YYYY')
  }

  protected setStatusTag(eligibilityStatusTag: { color?: string, value: string }): void {
    this.eligibilityStatusTag = new EligibilityStatusTag(eligibilityStatusTag)
  }

}
